import MainLayout from "../Layouts/main";

import { Outlet } from "react-router-dom";

import InternalLink from "../components/InternalLink";
import { useBluelagoon } from "@bluelagoon";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";

const Profile = () => {
    const { t } = useTranslation();
    const { isAdmin, isSuperAdmin, isFeatureEnabled } = useAuth();
    const {
        call: createStripeSession,
        error: stripeError,
        isLoading: stripeLoading,
    } = useBluelagoon({
        method: "insertNewStripeSession",
    });

    const handleBillingClick = async (e) => {
        e.preventDefault();
        const response = await createStripeSession({});
        if (response?.data?.sessionUrl) {
            window.location.href = response.data.sessionUrl;
        }
    };

    return (
        <div>
            <MainLayout>
                <div className="space-y-4">
                    <h1 className="page-title">
                        {t("profileIndex.accountSettings")}
                    </h1>

                    <div className="space-y-8">
                        <div className=" inline-flex border-b w-full items-center text-muted-foreground">
                            <InternalLink
                                value="profile"
                                to="/profile"
                                className="inline-flex-mb-[1px] border-b-transparent items-center justify-center whitespace-nowrap px-3 py-1 border-b-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[active=true]:bg-background data-[active=true]:text-foreground data-[active=true]:border-slate-500"
                            >
                                {t("profileIndex.profile")}
                            </InternalLink>
                            {(isAdmin || isSuperAdmin) && (
                                <InternalLink
                                    value="users"
                                    to="/profile/users"
                                    className="inline-flex-mb-[1px] border-b-transparent items-center justify-center whitespace-nowrap px-3 py-1 border-b-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[active=true]:bg-background data-[active=true]:text-foreground data-[active=true]:border-slate-500"
                                >
                                    {t("profileIndex.users")}
                                </InternalLink>
                            )}
                            {(isAdmin || isSuperAdmin) && (
                                <InternalLink
                                    value="users"
                                    to="/profile/groups"
                                    className="inline-flex-mb-[1px] border-b-transparent items-center justify-center whitespace-nowrap px-3 py-1 border-b-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[active=true]:bg-background data-[active=true]:text-foreground data-[active=true]:border-slate-500"
                                >
                                    {t("profileIndex.groups")}
                                </InternalLink>
                            )}
                            {(isAdmin || isSuperAdmin) && (
                                <InternalLink
                                    value="audit-logs"
                                    to="/profile/audit-logs"
                                    className="inline-flex-mb-[1px] border-b-transparent items-center justify-center whitespace-nowrap px-3 py-1 border-b-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[active=true]:bg-background data-[active=true]:text-foreground data-[active=true]:border-slate-500"
                                >
                                    {t("profileIndex.auditLogs")}
                                </InternalLink>
                            )}
                            {(isAdmin || isSuperAdmin) && (
                                <InternalLink
                                    value="security"
                                    to="/profile/security"
                                    className="inline-flex-mb-[1px] border-b-transparent items-center justify-center whitespace-nowrap px-3 py-1 border-b-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[active=true]:bg-background data-[active=true]:text-foreground data-[active=true]:border-slate-500"
                                >
                                    {t("profileIndex.security")}
                                </InternalLink>
                            )}
                            {(isAdmin || isSuperAdmin) && (
                                <InternalLink
                                    value="sso"
                                    to="/profile/sso"
                                    className="inline-flex-mb-[1px] border-b-transparent items-center justify-center whitespace-nowrap px-3 py-1 border-b-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[active=true]:bg-background data-[active=true]:text-foreground data-[active=true]:border-slate-500"
                                >
                                    {t("profileIndex.sso")}
                                </InternalLink>
                            )}
                            {/* make it avaiable for all users */}
                            {isFeatureEnabled("designSystem") && (
                                <InternalLink
                                    value="design-system"
                                    to="/profile/design-system"
                                    className="inline-flex-mb-[1px] border-b-transparent items-center justify-center whitespace-nowrap px-3 py-1 border-b-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[active=true]:bg-background data-[active=true]:text-foreground data-[active=true]:border-slate-500"
                                >
                                    {t("profileIndex.designSystem")}
                                </InternalLink>
                            )}
                            {/* <button
                                onClick={handleBillingClick}
                                disabled={stripeLoading}
                                className="inline-flex-mb-[1px] border-b-transparent items-center justify-center whitespace-nowrap px-3 py-1 border-b-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
                            >
                                {stripeLoading ? t("profileIndex.loading") : t("profileIndex.billing")}
                            </button> */}
                        </div>

                        {stripeError && (
                            <div className="text-red-500">
                                {t("profileIndex.errorLoadingBilling")}
                            </div>
                        )}

                        <Outlet />
                    </div>
                </div>
            </MainLayout>
        </div>
    );
};

export default Profile;
